import { useEffect } from 'react';
import { SNACKBAR_DURATION } from 'shared/constants/snackbar';

export function useAutoHideSnackbar(
  isVisible: boolean,
  onHide: () => void,
  duration?: number,
) {
  useEffect(() => {
    if (!isVisible) {
      return;
    }

    const timer = setTimeout(() => {
      onHide();
    }, duration ?? SNACKBAR_DURATION);

    return () => clearTimeout(timer);
  }, [isVisible, onHide, duration]);
}
